// extracted by css-extract-rspack-plugin
export default {"spaceXXSmall":"4px","sizeFluid":"100%","checkboxContainer":"form-input__checkboxContainer___UYILd"};